<template>
  <transition-group name="list-complete" tag="div" class="container">
    <div
      class="card list-complete-item"
      v-for="(card, index) in content"
      :key="index"
    >
      <button
        v-if="!card.show"
        class="btn-card medium-btn"
        @click="$emit('select', card.compare, card.id)"
      >
        Flip
      </button>
      <transition
        name="custom-classes-transition"
        enter-active-class="animate__animated animate__flipInY"
        leave-active-class="animate__animated animate__flipOutY"
      >
        <div v-if="card.show" style="position: absolute">
          <div class="img">
            <img
              :src="require('../assets/' + card.image)"
              :alt="card.alt"
              class="image"
            />
          </div>
        </div>
      </transition>
    </div>
  </transition-group>
</template>

<script>
export default {
  data() {
    return {};
  },
  emits: ["select"],
  methods: {
    sendData: function () {
      this.$emit("select");
    },
  },
  props: {
    content: Array,
  },
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s ease;
  display: flex;
  margin-right: 1rem;
}

.list-complete-enter-from,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(3rem);
}

.list-complete-leave-active {
  position: absolute;
}

.medium-btn {
  font-size: 2rem;
}

.btn-card {
  background: #fff;
  width: 90%;
  min-height: 15rem;
  border: 0;
  padding: 1rem;
  border-radius: 1rem;
  text-align: center;
}

.img {
  text-align: center;
  background: #853829;
  min-width: 14rem;
  min-height: 15rem;
  border-radius: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image {
  width: 12rem;
}

.card {
  min-width: 90vw;
  min-height: 15rem;
  margin: 1rem 0 0.5rem 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

@media (min-width: 545px) {

.card {
    min-width: 16rem;

    margin: 1rem 0.5rem;
  }

}

</style>